import React, { useEffect, useState } from 'react';
import { Container, Grid, makeStyles, Button, Typography, Paper, TextField } from '@material-ui/core';
import Page from 'components/Page';
import serviciosReportes from 'utils/serviciosReportes';
import { Header, Tabla, ModalFormulario, ModalGeneral, } from 'components';
import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import { Search } from 'react-feather';
import { Autocomplete } from "@material-ui/lab";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.info.main,
    "&:hover": {
      backgroundColor: theme.palette.info.light,
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Reportes = ({ permisos, usuario }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [frm, setFrm] = useState({gerente:"", programador:"", proyecto:""});
  const [gerentes, setGerentes] = useState([{nombre:"TODOS", idusuario:"-1"}]);
  const [programadores, setprogramadores] = useState([{nombre:"TODOS", idusuario:"-1"}]);
  const [proyectos, setProyectos] = useState([{nproyecto:"TODOS", idproyecto:"-1"}]);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
  const { register, handleSubmit, errors, watch, setValue, reset } = useForm();
  const [defaultt, setDefaultt] = useState([{ nombre: "TODOS", idusuario: "-1" }]);
  // const servicios = {
  //   cambioEstatus: (data) => serviciosSolicitudes.cambioEstatus(respuesta(cerrarAdvertencia), setCargando, {
  //     idsolicitud: data.idsolicitud, idpropuesta: data.idpropuesta, estatus: data.nestatus, tipo: data.tipo
  //   })
  // }

  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });
  const respuesta = onSuccess => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  }

  const buscarSolicitud = (buscar, e) => {

    // setData({}); //LIMPIAR DATA
    serviciosReportes.reporteTIS((data) => {
      setData(data);
    }, setCargando, {finicio:buscar.finicio,ffin:buscar.ffin, gerente: frm.gerente?.idusuario, programador:frm.programador?.idusuario, proyecto:frm.proyecto?.idproyecto });
  }

  const changeGte = (event, value) => {
    setFrm({...frm,gerente:value})
  };

  const changePro = (event, value) => {
    setFrm({...frm,programador:value})
  };

  const changeProy = (event, value) => {
    setFrm({...frm,proyecto:value})
  };

  const acciones = []; // { label: "Nueva orden", icon: <AddBox />, click: clickNuevo, disabled: !permisos.crear },
  const accionesFila = [];
  const columns = [

    { label: "PROYECTO(S)", name: 'proyectos', filtrar: true },
    { label: "SEMANA", name: 'nsemana', filtrar: true },
    { label: "RESPONSABLE", name: 'gerente', filtrar: true, tamano: 20  },
    { label: 'ACTIVIDAD', name: 'titulo', filtrar: true, tamano: 20 },
    { label: 'TIPO', name: 'tipe', filtrar: true, tamano: 7 },
    { label: 'ESTADO', name: 'nestatus', filtrar: true },
    // { label: "N. HORAS PROPUESTA", name: 'nhoras_propuesta', filtrar: true, tamano: 12 },
    { label: "N. HORAS REALES", name: 'nhoras_reales', filtrar: true, tamano: 15 },
    { label: 'FECHA INICIO (ESTIMADO)', name: 'prop_inicio', filtrar: true, tamano: 15 },
    { label: "FECHA FIN (ESTIMADO)", name: 'prop_fin', filtrar: true, tamano: 15 },
    { label: "FECHA INICIO (REAL)", name: 'fecha_inicio', filtrar: true, tamano: 15 },
    { label: "FECHA FIN (REAL)", name: 'fecha_termino', filtrar: true, tamano: 15 },
    { label: "FECHA ENTREGA", name: 'fecha_termino', filtrar: true },
    { label: "ENCARGADO (EJECUTAR TAREA)", name: 'reponsables', filtrar: true, tamano: 18  },
    { label: 'SOLICITANTE', name: 'ncrea', filtrar: true },
    { label: 'COMENTARIOS ADICIONALES', name: 'adicionales', filtrar: true },
    { label: "# SOLICITUD", name: 'idsolicitud', filtrar: true },    
  ];

  useEffect(() => {
    serviciosReportes.getGteProgra(
      (data) => {
        setGerentes(data.gerentes);
        setprogramadores(data.programadores);
        setProyectos(data.proyectos);
      },
      setCargando,
      {}
    );
  }, []);

;

  return (
    <Page
      className={classes.root}
      title="Reporte de solicitudes"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="Reportes" subtitle="TAREAS" />
        <form autocomplete="off" onSubmit={handleSubmit(buscarSolicitud)}>
          <Grid container spacing={2}>
            <Grid item md={2} xs={4}><Paper elevation={0}><TextField type="date" InputLabelProps={{ shrink: true }}
              variant="outlined" fullWidth size="small" label="Fecha inicio"
              name="finicio" inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
              error={Boolean(errors.finicio)} helperText={errors.finicio?.message}
            /></Paper></Grid>
            <Grid item md={2} xs={4}><Paper elevation={0}>
              <TextField type="date" InputLabelProps={{ shrink: true }}
              variant="outlined" fullWidth size="small" label="Fecha fin"
              name="ffin" inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
              error={Boolean(errors.ffin)} helperText={errors.ffin?.message}
              />
            </Paper></Grid>
            <Grid item md={3} xs={4}><Paper elevation={0}>
              <Autocomplete
                size="small"
                // options={ctl.gerentes}
                options={gerentes}
                getOptionLabel={(option) => option.nombre}
                defaultValue={ gerentes[0] }
                // getOptionSelected={(option, value) => option.nestatus == value.id}
                onChange={changeGte}
                // value={gerente}
                // style={{ width: 300 }}
                inputRef={register()}
                renderInput={(params) => (
                  <TextField
                    label="Gerente"
                    variant="outlined"
                    name="gerentes"
                    {...params}
                    error={Boolean(errors.gerente)}
                    helperText={errors.gerente}
                  />
                )}
              ></Autocomplete>
              
            </Paper></Grid>
            <Grid item md={2} xs={4}><Paper elevation={0}>
              <Autocomplete
                size="small"
                options={programadores}
                defaultValue={ programadores[0] }
                getOptionLabel={(option) => option.nombre}
                onChange={changePro}
                // getOptionSelected={(option, value) => option.nestatus == value.id}
                // value={frm.gerente}
                // style={{ width: 300 }}
                inputRef={register()}
                renderInput={(params) => (
                  <TextField
                    label="Programador"
                    variant="outlined"
                    {...params}
                    error={Boolean(errors.programador)}
                    helperText={errors.programador}
                  />
                )}
              ></Autocomplete>
            </Paper></Grid>
            <Grid item md={2} xs={4}><Paper elevation={0}>
              <Autocomplete
                size="small"
                options={proyectos}
                defaultValue={ proyectos[0] }
                getOptionLabel={(option) => option.nproyecto}
                onChange={changeProy}
                // getOptionSelected={(option, value) => option.nestatus == value.id}
                // value={frm.gerente}
                // style={{ width: 300 }}
                inputRef={register()}
                renderInput={(params) => (
                  <TextField
                    label="Proyecto"
                    variant="outlined"
                    {...params}
                    error={Boolean(errors.proyecto)}
                    helperText={errors.proyecto}
                  />
                )}
              ></Autocomplete>
            </Paper></Grid>
            <Grid item xs={1}><Button fullWidth color="primary" className={classes.search} size="medium" variant="contained" type="submit"><Search /></Button></Grid>
          </Grid>
        </form>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Tabla
              keyTabla='repTareas'
              rows={data}
              columns={columns}
              accionesTabla={acciones}
              accionesFila={accionesFila}
              filterGeneralDisabled={data.length > 0?false:true} 
              isSeleccionable={false}
              columnKey={'idsolicitud'}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Reportes;